export default (message) => {
  console.log(message)
  switch(message.code) {
    case 'auth/network-request-failed':
      message = 'Ha ocurrido un problema con su conexion, por favor revise la red o intente mas tarde'
      break;
    case 'auth/wrong-password':
      message = 'Contraseña incorrecta, por favor, verifique sus datos';
      break;
    case 'auth/too-many-requests': 
      message = 'Ha intentado iniciar sesion muchas veces, por favor, intente mas tarde'
      break;
    case 'auth/user-not-found':
      message = 'Usuario no registrado, por favor, verifique sus datos'
  }
  return message
}